/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Owner_3Inputs */

const en_mk_tb_example_owner_3 = /** @type {(inputs: Mk_Tb_Example_Owner_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner: founder`)
};

const id_mk_tb_example_owner_3 = /** @type {(inputs: Mk_Tb_Example_Owner_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanggung jawab: founder`)
};

/**
* | output |
* | --- |
* | "Owner: founder" |
*
* @param {Mk_Tb_Example_Owner_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_owner_3 = /** @type {((inputs?: Mk_Tb_Example_Owner_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Owner_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_owner_3(inputs)
	return en_mk_tb_example_owner_3(inputs)
});